var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsearch"},[_c('skysource-search',{attrs:{"floatingList":"true"},model:{value:(_vm.obsSkySource),callback:function ($$v) {_vm.obsSkySource=$$v},expression:"obsSkySource"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }